import type { ScrubDirection } from "@/lib/timeline/playback";
import { scrubHoldHandlers } from "./scrubHold";
import { IconFastForward, IconPause, IconPlay, IconSkip } from "./TimelineTransportIcons";

interface TimelineTransportScrubProps {
  playing: boolean;
  onPlayPause: () => void;
  onScrub: (direction: ScrubDirection) => void;
  onSkipScene: (direction: -1 | 1) => void;
}

export function TimelineTransportScrub({
  playing,
  onPlayPause,
  onScrub,
  onSkipScene,
}: TimelineTransportScrubProps) {
  return (
    <>
      <button
        type="button"
        className="timeline-transport__btn"
        aria-label="Previous scene"
        title="Previous scene"
        onClick={() => onSkipScene(-1)}
      >
        <IconSkip className="timeline-transport__icon" />
      </button>
      <button
        type="button"
        className="timeline-transport__btn"
        aria-label="Rewind"
        title="Rewind"
        {...scrubHoldHandlers(-1, onScrub)}
      >
        <IconFastForward className="timeline-transport__icon timeline-transport__icon--flip" />
      </button>
      <button
        type="button"
        className={[
          "timeline-transport__btn",
          "timeline-transport__btn--primary",
          playing ? "timeline-transport__btn--toggle-on" : "",
        ].filter(Boolean).join(" ")}
        onClick={onPlayPause}
        aria-label={playing ? "Pause" : "Play"}
        title={playing ? "Pause" : "Play"}
      >
        {playing ? (
          <IconPause className="timeline-transport__icon" />
        ) : (
          <IconPlay className="timeline-transport__icon" />
        )}
      </button>
      <button
        type="button"
        className="timeline-transport__btn"
        aria-label="Fast forward"
        title="Fast forward"
        {...scrubHoldHandlers(1, onScrub)}
      >
        <IconFastForward className="timeline-transport__icon" />
      </button>
      <button
        type="button"
        className="timeline-transport__btn"
        aria-label="Next scene"
        title="Next scene"
        onClick={() => onSkipScene(1)}
      >
        <IconSkip className="timeline-transport__icon timeline-transport__icon--flip" />
      </button>
    </>
  );
}
